import React, { useEffect, useRef, useState } from "react";
import styled, { keyframes, css } from "styled-components";
import { respondTo } from "../../util/breakpoints";
import * as colors from "../../util/colors";
import { rightIconMulberry, leftIconMulberry } from "../../util/icons";
import { ANCHORNAVBUTTONS } from "../../constants/z-index-map";
import iconClose from "../../assets/content-icons/icon-close-x-circle.svg";
import {
  plusIconGreen,
  plusIconDarkGreen,
  plusIconMulberry,
  minusBrandGreen,
  minusGreenDark,
  minusMulberry,
} from "../../util/icons";

const slideImg = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(20px);
  }
  50.001% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0);
  }
`;

const AnchorNavContainer = styled.div`
  // padding-top: 7px !important;
  background: ${colors.white};
  box-shadow: ${({ isMobileOpen }) =>
    isMobileOpen ? "none" : "0px 1px 1px 0px rgba(0, 0, 0, 0.05);"};
  padding: 12px 0;
  height: ${({ isMobileOpen }) => (isMobileOpen ? "auto" : "48px")};
  position: absolute;
  top: 100%;
  width: 100%;
  display: ${({ isMobileOpen }) => (isMobileOpen ? "block" : "flex")};
  align-items: center;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 0px;
    padding-top: ${({ isMobileOpen }) => (isMobileOpen ? "4px" : "0")};
  }

   ${respondTo.md`
        ${({ hyptheticNav }) =>
            hyptheticNav === 'present' &&
            `
                height: unset;
                > div {
                    height: unset;
                }
                a:first-child, 
                a:nth-child(2) {
                    text-wrap: unset;
                    // width: 100%;
                    min-width: 220px;
                    // text-align: left;


                }
                a:first-child {
                    min-width: 215px;
                }
                a:nth-child(2) {
                    min-width: 99px;
                }
            `
        }
    `}
`;

const AnchorNavScrollableArea = styled.div`
  overflow-x: scroll;
  width: 100%;
  ::-webkit-scrollbar {
    display: none;
  }

  span {
    text-transform: uppercase;
    font-size: 14px;
    color: ${colors.charcoal};
  }

  a {
    font-size: 16px;
    font-weight: 700;
    color: #004A85 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  ${respondTo.md`
    ${({ hyptheticNav }) =>
      hyptheticNav === "present" &&
      css`
        height: unset;
      `}
  `}
`;

const NavLine = styled.hr`
  height: 3px;
  width: 100%;
  background: linear-gradient(
    96deg,
    ${colors.mulberry} 47.42%,
    ${colors.mulberryLight} 100%
  );
  margin: 0;
  position: absolute;
  border: 0;

  &:nth-of-type(1) {
    top: 0;
  }
  &:nth-of-type(2) {
    bottom: 0;
  }

  @media (max-width: 769px) {
    height: 4px;
  }
`;

const AnchorNavContent = styled.div`
  max-width: 1032px;
  margin: ${({ isMobileOpen }) => (isMobileOpen ? "unset" : "0 auto")};
  font-size: 18px;
  font-weight: 400;
  color: ${colors.ink};
  width: ${({ isMobileOpen }) => (isMobileOpen ? "unset" : "100%")};

  .keytruda {
    color: ${colors.greenDark};
  }
  .lenvima {
    color: ${colors.mulberry};
  }

  ${respondTo.md`
    ${({ hyptheticNav }) =>
      hyptheticNav === "present" &&
      css`
        padding-top: unset;
      `}
  `}

  .menu-open {
    position: relative;
    ::after {
      content: "";
      position: absolute;
      top: 0;
      height: 2px;
      z-index: 9;
      background-color: #ebeAeb;
      width: 100%;
      max-width: calc(100% - 24px);
      left: 0;
      right: 0;
      margin: 0 auto;
    }
  }
`;

const ArrowButton = styled.button`
  background: ${colors.mist};
  width: 25px;
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: ${ANCHORNAVBUTTONS};
  border: 0;
  top: 0px;
  cursor: pointer;

  img {
    width: 7px;
    height: 12px;
  }

  &.left {
    left: 0;
  }
  &.right {
    right: 0;
  }
`;

const AnchorLinks = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items:center;
    gap: 20px;
    & > a {
    position: relative;
    white-space: nowrap;
    text-decoration: none;
    color: ${colors.ink};
        font-size: 16px;
    font-weight: 700;
    &:hover img{
        animation: ${slideImg} 0.3s both;
        }
    @media(min-width:769px){
    &:not(:first-of-type) {
      padding-left: 30px;
    }
    }
     @media(max-width:768px){
     img{
        padding-right:10px;
     }
     }
  }
    & > * {
        position: relative;
        white-space: nowrap;
        text-decoration: none;
        color: ${colors.ink};

        @media(min-width:769px){
            &:not(:first-child):after {
            content: '';
            position: absolute;
            right: -30px;
            position: absolute;
            right: -30px;
            width: 1px;
            height: 2em;
            background-color: ${colors.pebble};
            margin-left: 10px;
            vertical-align: middle;
        }
        }
        &:last-child:after {
            content: none;
        }
    }
        @media(max-width:768px){
        span{
            display:none;
        }
        }
        a{
        color:${colors.blueDark} !important;
        &:hover{
        color:${colors.focus} !important;
        }
        ::first-child{
            border-top:1px solid #000;
        }
        img{
            // padding-right:10px;
            @media(min-width:320px){
                margin-left:0 !important;
            }
        }
        }

    ${({ isMobileMenu }) =>
        isMobileMenu &&
        `
        flex-direction: column;
        gap: 15px;
        align-items: flex-start;

        & > * {
            padding: 0;
            &:after {
                content: none;
            }
        }
    `}
`;


const AnchorNav = ({ children, className, hyptheticNav }) => {
  const anchorRef = useRef(null);
  const [isLeftHidden, setIsLeftHidden] = useState(false);
  const [isRightHidden, setIsRightHidden] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const mainEl = document.querySelector("main");
    if (mainEl) {
      if (isOpen) {
        mainEl.classList.add("nav-open");
      } else {
        mainEl.classList.remove("nav-open");
      }
    }
  }, [isOpen]);

  const listenToResize = () => {
    if (anchorRef.current) {
      setIsLeftHidden(anchorRef.current.scrollLeft > 0);
      setIsRightHidden(
        anchorRef.current.scrollWidth >
          anchorRef.current.scrollLeft + anchorRef.current.clientWidth + 5
      );
    }
  };

  useEffect(() => {
    listenToResize();
    window.addEventListener("resize", listenToResize);

    if (anchorRef.current) {
      anchorRef.current.addEventListener("scroll", listenToResize);
    }

    return () => {
      window.removeEventListener("resize", listenToResize);
      if (anchorRef.current) {
        anchorRef.current.removeEventListener("scroll", listenToResize);
      }
    };
  }, []);

  return (
    <AnchorNavContainer
      hyptheticNav={hyptheticNav}
      isMobileOpen={isMobile && isOpen}
    >
      <NavLine />
      <AnchorNavContent className={className} hyptheticNav={hyptheticNav}>
        {isMobile ? (
          <>
            <button
              style={{
                background: "none",
                border: "none",
                fontSize: "14px",
                textTransform: "uppercase",
                padding: "10px 0px 10px",
                cursor: "pointer",
                color: "#000",
                fontWeight: "bold",
                display: "block",
                alignItems: "center",
                gap: "8px",
                width: "-webkit-fill-available",
                margin: "0 12px",
                height: "40px",
                // borderBottom: `2px solid ${colors.mist}`,
                
              }}
              onClick={() => setIsOpen(!isOpen)}
            >
              <div
                className="innerbtn"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span style={{ color: "#444444", fontWeight: "400" }}>
                  ON THIS PAGE:
                </span>
                <span style={{  height: "20px" }}>
                  {isOpen ? (
                    <img src={minusBrandGreen} alt="" />
                  ) : (
                    <img src={plusIconDarkGreen} alt="" />
                  )}
                </span>
              </div>
            </button>

            {isOpen && (
              <div
                className="menu-open"
                style={{
                  background: "#fff",
                  borderRadius: "4px",
                  padding: "10px 12px 15px 12px",
                }}
              >
                <AnchorLinks
                  hyptheticNav={hyptheticNav}
                  isMobileMenu={true}
                  onClick={() => setIsOpen(false)}
                >
                  {children}
                </AnchorLinks>
              </div>
            )}
          </>
        ) : (
          <AnchorNavScrollableArea ref={anchorRef} hyptheticNav={hyptheticNav}>
            {isLeftHidden && (
              <ArrowButton
                className="left"
                onClick={() => (anchorRef.current.scrollLeft -= 30)}
              >
                <img src={leftIconMulberry} alt="" />
              </ArrowButton>
            )}
            <AnchorLinks hyptheticNav={hyptheticNav}>{children}</AnchorLinks>
            {isRightHidden && (
              <ArrowButton
                className="right"
                onClick={() => (anchorRef.current.scrollLeft += 30)}
              >
                <img src={rightIconMulberry} alt="" />
              </ArrowButton>
            )}
          </AnchorNavScrollableArea>
        )}
      </AnchorNavContent>
      <NavLine />
    </AnchorNavContainer>
  );
};

export default AnchorNav;
